import { NgStyle } from '@angular/common';
import { Component, ElementRef, NgZone, ViewChild, ViewContainerRef } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faEllipsisV, faTrash, faSquareMinus, faSquarePlus, faSpinnerThird, faChevronRight, faClipboard, faCog, faEye, faEyeSlash, faCircleCheck, faCircleX, faCircleInfo, faMinusCircle } from '@fortawesome/pro-regular-svg-icons';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { DialogService } from './services/dialog/dialog.service';

@Component({
    selector: 'app-root',
    imports: [HeaderComponent, FooterComponent, NgStyle, RouterOutlet],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
    title = "efr.web";

    style!: any;

    @ViewChild('dialog', { read: ViewContainerRef })
    dialog?: ViewContainerRef;

    //
    constructor(private elementRef: ElementRef, private ngZone: NgZone, private dialogService: DialogService, iconLibrary: FaIconLibrary) {
        iconLibrary.addIcons(faEllipsisV, faSquareMinus, faSquarePlus, faTrash, faSpinnerThird, faChevronRight, faClipboard, faCog, faEye, faEyeSlash, faCircleCheck, faCircleX, faCircleInfo, faMinusCircle);
    }

    ngOnInit(): void {
        const observer = new ResizeObserver(entries => {
            this.ngZone.run(() => {
                this.style = {
                    "max-height": `${entries[0].contentRect.height - Math.round(["app-header", "app-footer"].map(e => (this.elementRef.nativeElement.querySelector(e) as HTMLElement).getBoundingClientRect().height).reduce((a, b) => a + b, 0))}px`
                };
            });
        });
        observer.observe(document.querySelector("body") as HTMLElement);

        this.dialogService.dialog$.subscribe(dialog => {
            if (!this.dialog)
                return;

            if (!dialog || !dialog.component)
                return;

            let componentRef = this.dialog.createComponent(dialog.component);
            (componentRef.instance as any).dialog = dialog;
        });

        this.dialogService.closeDialog$.subscribe(() => {
            if (!this.dialog)
                return;

            if (this.dialog.length) {
                this.dialog.remove(this.dialog.length - 1);
            }
        });
    }
}
